import { render } from "./TemplateMainList.vue?vue&type=template&id=034b9dd0"
import script from "./TemplateMainList.vue?vue&type=script&lang=js"
export * from "./TemplateMainList.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__